import { render, staticRenderFns } from "./assign-salesman-modal.vue?vue&type=template&id=18a2082c"
import script from "./assign-salesman-modal.vue?vue&type=script&lang=js"
export * from "./assign-salesman-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports